import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import ImagePreviewModal from "../../components/imageView/ImagePreviewModal";

const ViewVerfication = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const rawData = queryParams.get("EmployeeData");
  const safeJsonParse = (data: any) => {
    try {
      if (typeof data === "string") {
        return JSON.parse(data);
      }
      return data || {};
    } catch (error) {
      return {};
    }
  };

  let formlist = safeJsonParse(rawData) || {};
  const [locationName, setLocationName] = useState<string>("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const geoLocation = safeJsonParse(formlist?.geo_location) || {};

  const { lat, lon } = geoLocation;

  useEffect(() => {
    if (formlist?.geo_location) {
      fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`
      )
        .then((response) => response?.json())
        .then((data) => {
          if (data.display_name) {
            setLocationName(data?.display_name);
          } else {
            setLocationName("Location not found");
          }
        })
        .catch((error) => {
          console.error("Error fetching location:", error);
          setLocationName("Error fetching location");
        });
    }
  }, [formlist?.geo_location]);

  const openMap = (lat: any, lon: any) => {
    const url = `https://www.google.com/maps?q=${lat},${lon}`;
    window.open(url, "_blank");
  };

  const address = safeJsonParse(formlist?.customer?.address) || {};
  const par_address = safeJsonParse(formlist?.customer?.current_address) || {};

  const handleImageClick = (imgUrl: string) => {
    setSelectedImage(imgUrl);
    setShowImageModal(true);
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {formlist && (
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="container mt-5">
                  <h2>Verification Details</h2>
                  <div className="raw-div-1">
                    <div className="row">
                      <div className="mb-3 col-6">
                        <label htmlFor="name" className="form-label">
                          Customer Name
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.customer?.full_name}
                          required
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="rate" className="form-label">
                          Customer Email
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.customer?.email}
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="name" className="form-label">
                          Employee Name
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.employees?.full_name}
                          required
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="rate" className="form-label">
                          Employee Email
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.employees?.email}
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="rate" className="form-label">
                          Verification Type
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.verificationType}
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="rate" className="form-label">
                          Remark
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.remark}
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="address" className="form-label">
                          latitude
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={lat}
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="address" className="form-label">
                          longitude
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={lon}
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label
                          htmlFor="googleMap"
                          className="form-label d-flex align-items-center "
                        >
                          <span style={{ marginRight: 25 }}>Google Map</span>
                          <i
                            className="fa fa-map-marker-alt text-primary"
                            style={{ cursor: "pointer", fontSize: "2.2rem" }}
                            onClick={() => openMap(lat, lon)}
                            title="Open in Google Maps"
                          ></i>
                        </label>
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="address" className="form-label">
                          location
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={locationName}
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="name" className="form-label">
                          Financer Name
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.financer?.full_name}
                          required
                          disabled
                        />
                      </div>
                      <div className="mb-3 col-6">
                        <label htmlFor="rate" className="form-label">
                          Financer Email
                        </label>
                        <input
                          className="form-control"
                          value={formlist?.financer?.email}
                          disabled
                        />
                      </div>

                      <div className="mb-3 col-6">
                        <label htmlFor="address" className="form-label">
                          Current Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={`${address?.addressLine}, ${address?.city},${address?.state},${address?.country},${address?.pincode}`}
                          disabled
                        />
                      </div>

                      <div className="mb-3 col-6">
                        <label htmlFor="address" className="form-label">
                          Permanent Address
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={`${par_address?.addressLine1}, ${par_address?.city1},${par_address?.state1},${par_address?.country1},${par_address?.pincode1}`}
                          disabled
                        />
                      </div>
                      <div> Verification Images</div>
                      <div className="mb-3 col-6">
                        <img
                          onClick={() =>
                            handleImageClick(formlist?.staffVerificationImage)
                          }
                          src={formlist?.staffVerificationImage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <ImagePreviewModal
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          imageUrl={selectedImage}
        />
      </div>
    </>
  );
};

export default ViewVerfication;
